// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationResponseLineItem {
    static getAttributeTypeMap() {
        return ClaimAdjudicationResponseLineItem.attributeTypeMap;
    }
}
ClaimAdjudicationResponseLineItem.discriminator = undefined;
ClaimAdjudicationResponseLineItem.additionalProperties = false;
ClaimAdjudicationResponseLineItem.attributeTypeMap = [
    {
        "name": "amountPaid",
        "baseName": "amountPaid",
        "type": "number"
    },
    {
        "name": "claimLineId",
        "baseName": "claimLineId",
        "type": "number"
    },
    {
        "name": "rejectionCodes",
        "baseName": "rejectionCodes",
        "type": ""
    },
    {
        "name": "adjudicationCodes",
        "baseName": "adjudicationCodes",
        "type": ""
    },
];
//# sourceMappingURL=claimAdjudicationResponseLineItem.js.map